export default {
  selectSurvey: {
    heading: 'Select Survey',
    headingDefault: 'Select Default Survey',
    noDefault: 'No default survey'
  }
};